
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import { NextSeo } from "next-seo";
import useTranslation from "next-translate/useTranslation";
import Layout from "@/components/core/Layout";
import FindSalary from "@/components/become-consultant/FindSalary";
import BecomeConsultantHero from "@/components/become-consultant/BecomeConsultantHero";
import YourOpportunities from "@/components/become-consultant/YourOpportunities";
import ProfileAndDashboard from "@/components/become-consultant/ProfileAndDashboard";
import WhyVialantis from "@/components/become-consultant/WhyVialantis";
import request from "@/utils/request";

const Start = ({ opportunities, whyVialantis }) => {
  const { t } = useTranslation("become-consultant");

  return (
    <Layout>
      <NextSeo title={t`seoTitle`} description={t`subtitle`} />
      <BecomeConsultantHero />
      <YourOpportunities opportunities={opportunities} />
      <ProfileAndDashboard />
      <WhyVialantis whyVialantis={whyVialantis} />
      <FindSalary />
    </Layout>
  );
};

 async function _getStaticProps({ locale }) {
  const opportunities = await request.get(`/content/vialantis-features`, { headers: { "Accept-Language": locale } });
  const whyVialantis = await request.get(`/content/why-vialantis`, { headers: { "Accept-Language": locale } });

  return {
    props: {
      opportunities: opportunities.data,
      whyVialantis: whyVialantis.data,
    },
    revalidate: 60 * 60 * 24, // 1 day
  };
}

export default Start;


    export async function getStaticProps(ctx) {
        let res = _getStaticProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/start',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  